import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglePlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 107,
	height: 35,
	viewBox: "0 0 107 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.96289 0.5H103.037C104.935 0.500044 106.5 2.15349 106.5 4.375V30.625C106.5 32.8465 104.935 34.5 103.037 34.5H3.96289C2.06519 34.5 0.5 32.8465 0.5 30.625V4.375C0.5 2.15349 2.06519 0.500042 3.96289 0.5Z",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.3299 10.129C37.3299 10.6452 37.1856 11.0968 36.8247 11.4194C36.3918 11.8065 35.8866 12 35.2371 12C34.5876 12 34.0825 11.8065 33.6495 11.4194C33.2165 11.0323 33 10.5806 33 10C33 9.41935 33.2165 8.96774 33.6495 8.58065C34.0825 8.19355 34.5876 8 35.2371 8C35.5258 8 35.8144 8.06452 36.1031 8.19355C36.3918 8.32258 36.6082 8.45161 36.7526 8.64516L36.3918 8.96774C36.1031 8.64516 35.7423 8.51613 35.2371 8.51613C34.8041 8.51613 34.3711 8.64516 34.0825 8.96774C33.7216 9.22581 33.5773 9.6129 33.5773 10.0645C33.5773 10.5161 33.7216 10.9032 34.0825 11.1613C34.4433 11.4194 34.8041 11.6129 35.2371 11.6129C35.7423 11.6129 36.1031 11.4839 36.4639 11.1613C36.6804 10.9677 36.8247 10.7097 36.8247 10.3871H35.2371V9.87097H37.3299V10.129ZM40.6495 8.51613H38.701V9.74194H40.5052V10.1935H38.701V11.4194H40.6495V11.9355H38.1237V8.06452H40.6495V8.51613ZM43.0309 11.9355H42.4536V8.51613H41.2268V8.06452H44.2577V8.51613H43.0309V11.9355ZM46.3505 11.9355V8.06452H46.9278V11.9355H46.3505ZM49.3814 11.9355H48.8041V8.51613H47.5773V8.06452H50.5361V8.51613H49.3093V11.9355H49.3814ZM56.2371 11.4194C55.8041 11.8065 55.299 12 54.6495 12C54 12 53.4948 11.8065 53.0619 11.4194C52.6289 11.0323 52.4124 10.5806 52.4124 10C52.4124 9.41935 52.6289 8.96774 53.0619 8.58065C53.4948 8.19355 54 8 54.6495 8C55.299 8 55.8041 8.19355 56.2371 8.58065C56.6701 8.96774 56.8866 9.41935 56.8866 10C56.8866 10.5806 56.6701 11.0323 56.2371 11.4194ZM53.4949 11.0968C53.7835 11.3548 54.2165 11.5484 54.6495 11.5484C55.0825 11.5484 55.5155 11.4194 55.8041 11.0968C56.0928 10.8387 56.3093 10.4516 56.3093 10C56.3093 9.54839 56.165 9.16129 55.8041 8.90323C55.5155 8.64516 55.0825 8.45161 54.6495 8.45161C54.2165 8.45161 53.7835 8.58065 53.4949 8.90323C53.2062 9.16129 52.9897 9.54839 52.9897 10C52.9897 10.4516 53.134 10.8387 53.4949 11.0968ZM57.6804 11.9355V8.06452H58.3299L60.4227 11.0968V8.06452H61V11.9355H60.4227L58.1856 8.77419V11.9355H57.6804Z",
			fill: "black",
			stroke: "black",
			strokeWidth: .2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.7447 18.8373C51.9007 18.8373 50.4409 20.1154 50.4409 21.8905C50.4409 23.5947 51.9007 24.9438 53.7447 24.9438C55.5887 24.9438 57.0485 23.6657 57.0485 21.8905C57.0485 20.0444 55.5887 18.8373 53.7447 18.8373ZM53.7447 23.6657C52.7459 23.6657 51.9007 22.8846 51.9007 21.8195C51.9007 20.7544 52.7459 19.9734 53.7447 19.9734C54.7435 19.9734 55.5887 20.6834 55.5887 21.8195C55.5887 22.8846 54.7435 23.6657 53.7447 23.6657ZM46.5993 18.8373C44.7553 18.8373 43.2955 20.1154 43.2955 21.8905C43.2955 23.5947 44.7553 24.9438 46.5993 24.9438C48.4433 24.9438 49.9031 23.6657 49.9031 21.8905C49.9031 20.0444 48.4433 18.8373 46.5993 18.8373ZM46.5993 23.6657C45.6005 23.6657 44.7553 22.8846 44.7553 21.8195C44.7553 20.7544 45.6005 19.9734 46.5993 19.9734C47.5981 19.9734 48.4433 20.6834 48.4433 21.8195C48.4433 22.8846 47.5981 23.6657 46.5993 23.6657ZM38.0709 19.7604V21.0385H41.3747C41.2979 21.7485 40.9905 22.3166 40.6064 22.6716C40.1454 23.0976 39.3771 23.5947 38.0709 23.5947C35.9965 23.5947 34.4598 22.1036 34.4598 20.1864C34.4598 18.2692 36.0733 16.7781 38.0709 16.7781C39.1466 16.7781 39.9917 17.2041 40.6064 17.7012L41.6052 16.7781C40.76 16.068 39.6844 15.5 38.1478 15.5C35.3818 15.5 33 17.6302 33 20.1864C33 22.7426 35.3818 24.8728 38.1478 24.8728C39.6844 24.8728 40.76 24.4467 41.682 23.5237C42.604 22.6716 42.9113 21.4645 42.9113 20.5414C42.9113 20.2574 42.9114 19.9734 42.8345 19.7604H38.0709ZM72.9527 20.7544C72.6454 20.0444 71.8771 18.8373 70.1868 18.8373C68.4965 18.8373 67.1135 20.0444 67.1135 21.8905C67.1135 23.5947 68.4965 24.9438 70.3404 24.9438C71.8002 24.9438 72.7222 24.0917 73.0295 23.5947L71.9539 22.8846C71.5697 23.3817 71.1087 23.7367 70.3404 23.7367C69.5721 23.7367 69.1111 23.4527 68.727 22.8136L73.1064 21.1095L72.9527 20.7544ZM68.4965 21.7485C68.4965 20.6124 69.4953 19.9734 70.1868 19.9734C70.7246 19.9734 71.2624 20.2574 71.4161 20.6124L68.4965 21.7485ZM64.8853 24.6598H66.3452V15.784H64.8853V24.6598ZM62.5804 19.4763C62.1962 19.1213 61.5816 18.7663 60.8132 18.7663C59.1998 18.7663 57.6631 20.1154 57.6631 21.8195C57.6631 23.5237 59.1229 24.8018 60.8132 24.8018C61.5816 24.8018 62.1962 24.4467 62.5035 24.0917H62.5804V24.5178C62.5804 25.6538 61.8889 26.2929 60.8132 26.2929C59.9681 26.2929 59.3534 25.7249 59.1998 25.2278L57.9704 25.7249C58.3546 26.5059 59.2766 27.5 60.8901 27.5C62.5804 27.5 63.9634 26.5769 63.9634 24.3757V18.9793H62.5804V19.4763ZM60.8901 23.6657C59.8913 23.6657 59.0461 22.8846 59.0461 21.8195C59.0461 20.7544 59.8913 19.9734 60.8901 19.9734C61.8889 19.9734 62.6572 20.7544 62.6572 21.8195C62.6572 22.8846 61.8889 23.6657 60.8901 23.6657ZM79.6371 15.784H76.1797V24.6598H77.6395V21.3225H79.6371C81.2506 21.3225 82.7872 20.2574 82.7872 18.5533C82.7872 16.8491 81.2506 15.784 79.6371 15.784ZM79.714 20.0444H77.6395V16.9911H79.714C80.7896 16.9911 81.4043 17.8432 81.4043 18.4822C81.3274 19.2633 80.7128 20.0444 79.714 20.0444ZM88.5496 18.7663C87.474 18.7663 86.3983 19.1923 86.0142 20.1154L87.3203 20.6124C87.6277 20.1154 88.0887 19.9734 88.6265 19.9734C89.3948 19.9734 90.0863 20.3994 90.1631 21.1095V21.1805C89.9326 21.0385 89.318 20.8254 88.7033 20.8254C87.3203 20.8254 85.9374 21.5355 85.9374 22.8136C85.9374 24.0207 87.0898 24.8018 88.3191 24.8018C89.318 24.8018 89.779 24.3757 90.1631 23.9497H90.24V24.6598H91.6229V21.2515C91.4693 19.6893 90.1631 18.7663 88.5496 18.7663ZM88.396 23.6657C87.935 23.6657 87.2435 23.4527 87.2435 22.8846C87.2435 22.1746 88.0886 21.9615 88.7801 21.9615C89.3948 21.9615 89.7021 22.1036 90.0863 22.2456C89.9326 23.0976 89.1643 23.6657 88.396 23.6657ZM96.4634 18.9793L94.8499 22.8136H94.7731L93.0827 18.9793H91.5461L94.0816 24.3757L92.6217 27.358H94.0816L98 18.9793H96.4634ZM83.5556 24.6598H85.0154V15.784H83.5556V24.6598Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.29268 8.25C9.07317 8.46228 9 8.81607 9 9.24063V24.8784C9 25.303 9.14634 25.6568 9.36585 25.869L9.43902 25.9398L18.5121 17.1657V17.0241L9.29268 8.25Z",
			fill: "url(#paint0_linear_8247_3511)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4375 20.1376L18.4375 17.2365V17.0242L21.4375 14.123L21.5106 14.1938L25.096 16.1751C26.1203 16.7411 26.1203 17.661 25.096 18.2271L21.4375 20.1376Z",
			fill: "url(#paint1_linear_8247_3511)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5084 20.0666L18.4353 17.0947L9.28906 25.9396C9.65491 26.2934 10.1671 26.2934 10.8256 26.0104L21.5084 20.0666Z",
			fill: "url(#paint2_linear_8247_3511)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5084 14.1232L10.8256 8.25018C10.1671 7.89639 9.65491 7.96714 9.28906 8.32094L18.4353 17.0951L21.5084 14.1232Z",
			fill: "url(#paint3_linear_8247_3511)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M21.4353 19.9961L10.8256 25.7983C10.2403 26.1521 9.72808 26.0814 9.36223 25.7983L9.28906 25.8691L9.36223 25.9399C9.72808 26.2229 10.2403 26.2937 10.8256 25.9399L21.4353 19.9961Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .12,
			d: "M9.29268 25.7981C9.07317 25.5858 9 25.232 9 24.8075V24.8782C9 25.3028 9.14634 25.6566 9.36585 25.8689V25.7981H9.29268ZM25.0974 18.0146L21.4389 19.9959L21.512 20.0666L25.0974 18.0854C25.6096 17.8023 25.8291 17.4485 25.8291 17.0947C25.8291 17.4485 25.5364 17.7316 25.0974 18.0146Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .25,
			d: "M10.8292 8.3204L25.0974 16.1747C25.5364 16.4577 25.8291 16.7407 25.8291 17.0945C25.8291 16.7407 25.6096 16.387 25.0974 16.1039L10.8292 8.24965C9.80487 7.68357 9 8.10813 9 9.24027V9.31103C9 8.24965 9.80487 7.75433 10.8292 8.3204Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8247_3511",
				x1: 17.634,
				y1: 9.10619,
				x2: 5.76516,
				y2: 21.3787,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#00A0FF" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .007,
						stopColor: "#00A1FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#00BEFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .512,
						stopColor: "#00D2FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .76,
						stopColor: "#00DFFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#00E3FF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8247_3511",
				x1: 26.4379,
				y1: 17.0956,
				x2: 8.73298,
				y2: 17.0956,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE000" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .409,
						stopColor: "#FFBD00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .775,
						stopColor: "#FFA500"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FF9C00"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_8247_3511",
				x1: 19.8453,
				y1: 18.7194,
				x2: 3.75093,
				y2: 35.362,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF3A44" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C31162"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_8247_3511",
				x1: 7.0186,
				y1: 3.06778,
				x2: 14.2058,
				y2: 10.4999,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#32A071" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .069,
						stopColor: "#2DA771"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .476,
						stopColor: "#15CF74"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .801,
						stopColor: "#06E775"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#00F076"
					})
				]
			})
		] })
	]
});
export default SvgGooglePlay;
